/* "Continue your page" (2026-10-25, after the Tribute.co comparison): the dashboard remembers, on this device only, the
   last page it opened, so the site header and My pages can offer the way straight back. Sign-out forgets it
   (lib/forget.ts). Nothing leaves the browser. */
export interface LastPage { slug: string; name: string; at: number }
const KEY = "ksp_last_page";

export function rememberPage(slug: string, name: string, now = Date.now()): void {
  if (!slug || !name) return;
  try { localStorage.setItem(KEY, JSON.stringify({ slug, name, at: now })); } catch { /* private mode */ }
}
export function lastPage(): LastPage | null {
  try { return parseLastPage(localStorage.getItem(KEY)); } catch { return null; }
}
/* Pure: a stored value back into a LastPage, or null when it is missing, malformed or older than 90 days. */
export function parseLastPage(raw: string | null, now = Date.now()): LastPage | null {
  if (!raw) return null;
  try {
    const v = JSON.parse(raw) as Partial<LastPage>;
    if (typeof v.slug !== "string" || !/^[a-z0-9-]{1,64}$/.test(v.slug) || typeof v.name !== "string" || !v.name.trim() || typeof v.at !== "number") return null;
    if (now - v.at > 90 * 86400e3) return null;
    return { slug: v.slug, name: v.name.trim().slice(0, 60), at: v.at };
  } catch { return null; }
}
/* "Lee's page" — the possessive the header and the card use. Pure. */
export const pageLabel = (name: string): string => name + (/s$/i.test(name) ? "'" : "'s") + " page";
/* "opened 2 hours ago" / "opened yesterday" / "opened 5 days ago". Pure. */
export function openedAgo(at: number, now = Date.now()): string {
  const m = Math.max(0, Math.round((now - at) / 60000));
  if (m < 2) return "opened just now";
  if (m < 60) return "opened " + m + " minutes ago";
  const h = Math.round(m / 60); if (h < 24) return "opened " + h + (h === 1 ? " hour" : " hours") + " ago";
  const d = Math.round(h / 24); return d === 1 ? "opened yesterday" : "opened " + d + " days ago";
}
